import Skeleton from "@/v2-ui/skeleton"
import cn from "@/v2-ui/utils/utils.cn"
import Dot from "@/v2-backoffice-client/components/dot/Dot"
import Link from "@/v2-backoffice-client/components/link"
import TranslationSidebarInfo from "@/v2-backoffice-client/translation/sidebar/TranslationSidebarInfo"
import type { SidebarInfo } from "@/v2-backoffice-client/translation/sidebar/translation.sidebar.utils"

export type TranslationSidebarItemProps = {
  label: string
  featureCode: string
  info: SidebarInfo
  count: number | null
  loading: boolean
  variant: "success-1" | "warning" | "destructive" | "muted"
  isActive: boolean
  to: string
}

function TranslationSidebarItem(props: TranslationSidebarItemProps) {
  const { label, featureCode, info, count, loading, variant, isActive, to } =
    props
  return (
    <Link
      to={to}
      variant="unstyled"
      iconSrc={null}
      data-feature-code={featureCode}
      aria-current={isActive ? "page" : undefined}
      className={cn(
        "translation-sidebar-item",
        isActive && "translation-sidebar-item-active",
      )}
    >
      <Dot variant={variant} className="shrink-0" />
      <span className="translation-sidebar-item-name">{label}</span>
      <TranslationSidebarInfo {...info} />
      {loading ? (
        <Skeleton className="h-3 w-6 rounded-sm bg-muted-foreground/20" />
      ) : count !== null ? (
        <span className="translation-sidebar-item-count">{count}</span>
      ) : null}
    </Link>
  )
}

export default TranslationSidebarItem
